<template>
  <div class="section12" alt="">
    <img class="bkg_bx" src="@/assets/certificates/earth.png" alt="" />
    <div class="cont">
      <div v-touch:swipe.left="ftr2Left" v-touch:swipe.right="ftr2Right">
        <div class="contTitle">相关资质证书</div>
        <div class="contItems">
          <div class="contItemsPart" v-show="certificate_part === 0">
            <div class="item">
              <img
                @click="showImg(11)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303221825455f77a954116138.png"
                alt="高新技术企业"
              />
              <p class="desc">高新技术企业</p>
            </div>
            <div class="item">
              <img
                @click="showImg(5)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161441485f6fec146c4dd0.png"
                alt="软件企业认证"
              />
              <p class="desc">软件企业认证</p>
            </div>

            <div class="item">
              <img
                @click="showImg(8)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161444435f6fecbb4a614c.png"
                alt="软件产品证书"
              />
              <p class="desc">软件产品证书</p>
            </div>

            <div class="item">
              <img
                @click="showImg(6)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161454215f6feee2480b48.png"
                alt="上海软件行业成员单位"
              />
              <p class="desc">上海软件行业<br />成员单位</p>
            </div>

            <div class="item">
              <img
                @click="showImg(3)"
                class="img"
                src="@/assets/certificates/iso27001@2x.png"
                alt="ISO27001信息安全管理体系认证"
              />
              <p class="desc">信息安<br />全管理体系认证</p>
            </div>
            <div class="item">
              <img
                @click="showImg(4)"
                class="img"
                src="@/assets/certificates/iso9001@2x.png"
                alt="ISO9001质量管理体系认证"
              />
              <p class="desc">质量管理<br />体系认证</p>
            </div>
          </div>
          <div class="contItemsPart" v-show="certificate_part === 1">
            <div class="item">
              <img
                @click="showImg(10)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161455045f6fef0bcfb11c.png"
                alt="信息系统安全等级保护三级认证"
              />
              <p class="desc">信息系统安全等级<br />保护三级认证</p>
            </div>

            <div class="item">
              <img
                @click="showImg(7)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161454445f6feef85a6244.png"
                alt="卓信大数据成员单位"
              />
              <p class="desc">卓信大数据<br />成员单位</p>
            </div>

            <div class="item">
              <img
                @click="showImg(12)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/20230815101643602ecc52e5abe8.png"
                alt="海光合作认证"
              />
              <p class="desc">海光合作认证</p>
            </div>

            <div class="item">
              <img
                @click="showImg(0)"
                class="img"
                src="@/assets/certificates/kylinsoft@2x.png"
                alt="麒麟软件NeoCertify认证"
              />
              <p class="desc">麒麟软件<br />NeoCertify认证</p>
            </div>
            <div class="item">
              <img
                @click="showImg(1)"
                class="img"
                src="@/assets/certificates/tongxin@2x.png"
                alt="麒麟软件NeoCertify认证"
              />
              <p class="desc">统信认证</p>
            </div>
            <div class="item">
              <img
                @click="showImg(2)"
                class="img"
                src="@/assets/certificates/fangde@2x.png"
                alt="麒麟软件NeoCertify认证"
              />
              <p class="desc">中科方德认证</p>
            </div>
          </div>
          <div class="contItemsPart" v-show="certificate_part === 2">
            <div class="item">
              <img
                @click="showImg(9)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/202303161445055f6fecd0c1b5d0.png"
                alt="信创技术活动单位"
              />
              <p class="desc">信创技术活动单位</p>
            </div>
            <div class="item">
              <img
                @click="showImg(13)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/2024011517401660ef8cd247e58c.png"
                alt="环境管理体系认证"
              />
              <p class="desc">环境管理体系认证</p>
            </div>
            <div class="item">
              <img
                @click="showImg(14)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/2024011517394060ef8cafd92ed0.png"
                alt="职业健康安全管理体系认证"
              />
              <p class="desc">职业健康安全管理体系认证</p>
            </div>
            <div class="item">
              <img
                @click="showImg(15)"
                class="img"
                src="https://todeskcdnspeed.todesk.com/2024020110323261048ceb663774.png"
                alt="信息技术服务管理体系认证"
              />
              <p class="desc">信息技术服务管理体系认证</p>
            </div>
          </div>
        </div>
        <div class="dots">
          <p class="dotsItem" :class="{'active': item === certificate_part + 1}" v-for="item in 3" :key="item"></p>
        </div>
      </div>

      <transition name="certificatefade">
        <div class="showCertificate" v-if="show_certificate" @click="hideImg">
          <div class="bx">
            <div class="bx_inner">
              <img
                :src="certificate_img"
                class="imgCertificate"
                alt="资质证书"
              />
              <img
                src="@/assets/certificates/close@2x.png"
                @click="showImg(-1)"
                class="closeCertificate"
                alt="关闭"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ismb: {
      type: Boolean,
      default: false,
    },
    hidebkg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show_certificate: false,
      certificate_img: "",
      certificate_list: [
        require("@/assets/certificates/kylinsoft_img@2x.png"),
        require("@/assets/certificates/tongxin_img@2x.png"),
        require("@/assets/certificates/fangde_img@2x.png"),
        require("@/assets/certificates/iso27001_img@2x.png"),
        require("@/assets/certificates/iso9001_img@2x.png"),
        "https://todeskcdnspeed.todesk.com/202303161211055f6fca64976fe4.png",
        "https://todeskcdnspeed.todesk.com/202303161500185f6ff036d1d7e4.png",
        "https://todeskcdnspeed.todesk.com/202303161501415f6ff085dc6c98.png",
        "https://todeskcdnspeed.todesk.com/202303161214115f6fcb16012904.png",
        "https://todeskcdnspeed.todesk.com/202308221153526037af17e22cac.png",
        "https://todeskcdnspeed.todesk.com/202303161502295f6ff0b3f69a08.png",
        "https://todeskcdnspeed.todesk.com/202303311425075f82c453af8b98.png",
        "https://todeskcdnspeed.todesk.com/20230815102620602ece78a4066c.png",
        "https://todeskcdnspeed.todesk.com/2024011517385560ef8c84d8b1ec.png",
        "https://todeskcdnspeed.todesk.com/2024011517392360ef8c9fef5024.png",
        "https://todeskcdnspeed.todesk.com/2024020110443161048f99e2ee8c.png",
      ],
      certificate_part: 0,
    };
  },
  computed: {
    new_certificate_list() {
      const res = [...this.certificate_list];
      if (this.$route.path && this.$route.path.indexOf("/desktron") !== -1) {
        res[0] =
          "https://todeskcdnspeed.todesk.com/2023112014315260a8fa43bf8eb0.png";
        res[1] =
          "https://todeskcdnspeed.todesk.com/2023112014313960a8fa374b0890.png";
      }
      return res;
    },
  },
  methods: {
    ftr2Left() {
      if (this.certificate_part == 2) {
        this.certificate_part = 0;
      } else {
        this.certificate_part++;
      }
    },
    ftr2Right() {
      if (this.certificate_part == 0) {
        this.certificate_part = 2;
      } else {
        this.certificate_part--;
      }
    },
    showImg(val) {
      if (val === -1) {
        this.allowScroll();
        this.show_certificate = false;
      } else {
        this.stopScroll();
        this.certificate_img = this.new_certificate_list[val];
        this.show_certificate = true;
      }
    },
    hideImg() {
      if (this.show_certificate) {
        this.show_certificate = false;
      }
    },
    //阻止body滚动
    stopScroll() {
      // if(this.ismb){
      //     return
      // }
      // let m = function(e){e.preventDefault();};
      // document.body.style.overflow='hidden';
      // document.addEventListener("touchmove",m,{ passive:false });
    },
    allowScroll() {
      // if(this.ismb){
      //     return
      // }
      // let m =function(e){e.preventDefault();};
      // document.body.style.overflow='';
      // document.removeEventListener("touchmove",m,{ passive:true });
    },
  },
};
</script>
<style lang="less" scoped>
.section12 {
  width: 100%;
  overflow: hidden;
  position: relative;
  // height: 280px;
  padding-bottom: 40px;
  z-index: 1;
  background: #f7f8fa;
  .bkg_bx {
    position: absolute;
    bottom: 0;
    left: -75px;
    height: 233px;
    width: auto;
    display: block;
    margin: auto;
    z-index: -1;
  }
  .cont {
    z-index: 1;
    padding-top: 32px;
    height: 100%;
    box-sizing: border-box;
  }
  .contTitle {
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #131314;
    text-align: center;
  }
  .contItems {
    margin-top: 30px;
    padding: 0 20px 20px;
    .contItemsPart {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
    }
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 100px;
      padding: 8px 2px 0;
      text-align: center;
      background: #fff;
      box-sizing: border-box;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      margin-bottom: 10px;
      img {
        height: 34px;
        width: auto;
      }
      .desc {
        width: 100%;
        margin-top: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7f7f7f;
        line-height: 17px;
        text-align: center;
        padding: 0;
      }
    }
    .item:active {
      background-color: #cccfd4;
    }
  }
  .dots {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    .dotsItem{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background: #D8D8D8;
      margin-left: 4px;
      margin-right: 4px;
      &.active {
        width: 20px;
        background: #0065DD;
      }
    }

  }
  .showCertificate {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 9, 23, 0.69);
    z-index: 10;
    .bx {
      width: 100%;
      height: 96%;
      margin-top: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .bx_inner {
        width: 300px;
        position: relative;
      }
      .imgCertificate {
        width: 280px;
        height: auto;
      }
      .closeCertificate {
        position: absolute;
        width: 20px;
        height: auto;
        right: -10px;
        top: 0;
      }
    }
  }
  // 过渡效果
  .certificatefade-enter-active,
  .certificatefade-leave-active {
    transition: opacity 0.3s;
  }
  .certificatefade-enter,
  .certificatefade-leave-to {
    opacity: 0;
  }
}
.section12.hidebkg {
  background: #fff;
  padding-top: 32px;
  padding-bottom: 40px;
}
</style>
